import React, { useMemo } from "react";

export default function Dashboard() {
  return (
    <div className="page-layout">
      <div className="page-header">
        <h2 className="title">Dashboard</h2>
        <div className="right">
          <a href="#" className="btn btn-primary">
            <i className="fa-solid fa-plus"></i> New Product
          </a>
        </div>
      </div>

      <div className="section-card">
        <h3>Dashboard Mocked</h3>
      </div>
    </div>
  );
}
